export enum SubmitSteps {
    Confirmation = 'C',
    CreateLoanFailure = 'CLF',
    CreateLoanSuccess = 'CLS'
}